import { useStaticQuery, graphql } from "gatsby";
import Header from "../../layout/improved-header";

export default function NavGraduateStudies({
  cssClass,
  page,
  miscLinks,
  ctas,
}) {
  const navGraduateStudies = useStaticQuery(graphql`
    query GradMenuQuery {
      sanitySection(id: { eq: "-e0fe27b0-13cc-548f-afa7-0fc2c9c055e7" }) {
        id
        menus {
          items {
            menuItems {
              internalLink {
                ... on SanityAcademicProgramPage {
                  id
                  slug {
                    current
                  }
                }
                ... on SanityNews {
                  id
                  title
                }
                ... on SanityPage {
                  id
                  path
                }
                ... on SanityNewsPost {
                  id
                  slug {
                    current
                  }
                }
              }
              externalLink
              isExternal
              label
            }
            label
            externalLink
            internalLink {
              ... on SanityAcademicProgramPage {
                id
                slug {
                  current
                }
              }
              ... on SanityNews {
                id
                title
                path
              }
              ... on SanityPage {
                id
                path
              }
              ... on SanityNewsPost {
                id
                slug {
                  current
                }
              }
            }
          }
        }
        _id
      }
    }
  `);

  const navGraduateStudiesForHamburger =
    navGraduateStudies.sanitySection?.menus[0]?.items.map((item) => {
      const label = item.label;
      let url = "";
      url = item?.internalLink?.path
        ? item.internalLink.path
        : item.externalLink;

      let columns = [];

      let startsWith = "/";

      if (item.menuItems?.length > 0) {
        columns = item.menuItems.map((menuItem, index) => {
          item = {
            label: menuItem.label,
            url:
              menuItem?.internalLink?.path !== undefined
                ? menuItem.internalLink.path
                : menuItem.externalLink,
          };
          return item;
        });
        columns.unshift({ label, url });
        columns = [columns];
        startsWith = "#";
      }

      return {
        label: label,
        startsWith: startsWith,
        columns: columns,
        url: columns.length > 0 ? undefined : url,
      };
    });

  return (
    <Header
      isHamburgerOnly={true}
      cssClass={cssClass}
      page={page}
      nav={navGraduateStudiesForHamburger}
      miscLinks={miscLinks}
      ctas={ctas}
    />
  );
}
